// removed by extract-text-webpack-plugin
module.exports = {"Loader":"Spinner__Loader__3dgUo","load2":"Spinner__load2__1sg5x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 131
// module chunks = 2